module.exports = __webpack_public_path__ + "static/virtual-reality-peace-science-society-abe4c69e6552a2fc01ef07a0f9b70612.jpg";